<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <VModal :disable-backdrop-click="false" :disable-close="false" @close="$emit('close')">
        <template #default="modalProps">
          <div class="rounded shadow-xs w-full max-w-6xl mx-auto">
            <div class="rounded shadow-lg bg-white overflow-hidden">
              <div class="px-4 sm:px-6 py-5 border-b">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <h1 class="text-sm">New SMS Campaign</h1>
                  </div>
                </div>
              </div>
              <template v-if="fetchDataProps.status.resolved">
                <div class="p-4 sm:p-6">
                  <SmsCampaignForm
                    :account-id="accountId"
                    :default-data="defaultData"
                    :from-options="fromOptions"
                    :action="action"
                    @saved="modalProps.close"
                  />
                </div>
              </template>
            </div>
          </div>
        </template>
      </VModal>
    </template>
  </BaseFetchData>
</template>

<script>
import SmsCampaignForm from '../SmsCampaignForm.vue';

import { ApiClient } from '@/api/client';

const client = new ApiClient('/api/v2');

export default {
  name: 'CreateSmsCampaignDialog',
  components: {
    SmsCampaignForm,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      fromOptions: [],
    };
  },
  methods: {
    fetchData() {
      return client.get(`/accounts/${this.accountId}/integrations/smses/me`).then((response) => {
        this.fromOptions = (response?.data?.data || []).map((item) => ({
          value: item.id,
          label: item.sms_from,
        }));

        return Promise.resolve();
      });
    },
  },
};
</script>
